import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';

import { CustomValidators } from 'ng2-validation';
import { Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';

import { NotificationService } from 'src/app/core/services/notification.service';
import { AccountState, isAuthenticating, login } from 'src/app/core/store';

@Component({
  selector: 'app-auth-form',
  templateUrl: './auth-form.component.html',
  styleUrls: ['./auth-form.component.less'],
})
export class AuthFormComponent implements OnInit {
  password: FormControl;
  authForm: FormGroup;
  isSubmitting$: Observable<boolean>;
  passwordVisible = false;
  ngUnsubscribe: Subject<any> = new Subject();
  showSuccessSignupAlert = false;
  showEmailVerificationAlert = false;

  constructor(
    // private modalService: NzModalService,
    private notificationService: NotificationService,
    private fb: FormBuilder,
    private store: Store<AccountState>
  ) {
    this.password = new FormControl('', [
      Validators.maxLength(40),
      Validators.required,
      Validators.minLength(8),
    ]);

    this.authForm = this.fb.group(this.signinFormModel());
  }

  ngOnInit(): void {
    this.isSubmitting$ = this.store.select(isAuthenticating);
  }

  signinFormModel(): any {
    return {
      email: [
        '',
        [Validators.required, Validators.maxLength(40), CustomValidators.email],
      ],
      password: this.password,
    };
  }

  submitForm(): void {
    this.store.dispatch(login(this.authForm.value));
  }
}
